import { render, staticRenderFns } from "./ItemListLink.vue?vue&type=template&id=19913ca4&scoped=true&"
import script from "./ItemListLink.vue?vue&type=script&lang=js&"
export * from "./ItemListLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19913ca4",
  null
  
)

export default component.exports